import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Box, Grid, Button, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';
import { Iconify } from 'src/components/iconify';

import { useOrganization } from '@/context/organization-context';
import { useIntegrationsControllerListIntegrations } from '@/apis/backend/generated/integrations/integrations';
import { IntegrationResponseDtoType } from '@/apis/backend/generated/models/integrationResponseDtoType';
import { IntegrationResponseDtoStatus } from '@/apis/backend/generated/models/integrationResponseDtoStatus';

import ShopifyIntegration from '@/components/settings/ShopifyIntegration';
import OrdersCard from '@/components/shopify/OrdersCard';
import ProductsCard from '@/components/shopify/ProductsCard';
import CustomersCard from '@/components/shopify/CustomersCard';

export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
)({
  component: ShopifyIntegrationPage,
});

function ShopifyIntegrationPage() {
  const navigate = useNavigate();
  const { orgId, clientId } = Route.useParams();
  const { activeOrganization, activeClient } = useOrganization();

  const { data: integrationsData } = useIntegrationsControllerListIntegrations(
    activeOrganization?.id || '',
    activeClient?.id || '',
    {
      query: {
        enabled: !!activeOrganization?.id && !!activeClient?.id,
        staleTime: 30000,
      },
    }
  );

  const shopifyIntegration = integrationsData?.integrations?.find(
    (i) => i.type === IntegrationResponseDtoType.shopify
  );

  const isConnected =
    shopifyIntegration?.status === IntegrationResponseDtoStatus.active ||
    shopifyIntegration?.status === IntegrationResponseDtoStatus.syncing;

  return (
    <Box>
      <Button
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        onClick={() =>
          navigate({
            to: paths.dashboard.orgSettings(orgId).client.clientIntegrations(clientId),
          })
        }
        sx={{ mb: 2, textTransform: 'none' }}
      >
        Back to Integrations
      </Button>
      <ShopifyIntegration />

      {isConnected && (
        <>
          <Typography variant="h5" sx={{ mt: 4, mb: 3 }}>
            Synced Data
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <ProductsCard />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <OrdersCard />
            </Grid>
            <Grid size={12}>
              <CustomersCard />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
}
